module.exports = __webpack_public_path__ + "img/hero-mobile.f65630d6.png";